import {Button} from 'platform/components';
import {HStack, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {RateMatrixCellData} from '../types/RateMatrixCellData';
import {openRateMatrixBulkRatesDialog} from './openRateMatrixBulkRatesDialog';

interface RateMatrixBulkActionsProps extends RequiredTestIdProps {
  selectedCellKeys: string[];
  onClear: VoidFunction;
  onApply: (rates: RateMatrixCellData) => void;
  onRemove: VoidFunction;
}

export function RateMatrixBulkActions(props: RateMatrixBulkActionsProps) {
  const selectedCount = props.selectedCellKeys.length;

  const handleOpenDialog = () =>
    openRateMatrixBulkRatesDialog({
      selectedCount,
      onSubmit: props.onApply,
      onRemove: props.onRemove,
      testId: suffixTestId('bulkRates', props),
    });

  return (
    <HStack spacing={2} align="center" wrap data-testid={suffixTestId('bulkActions', props)}>
      <Text size="small" color="secondary">
        {i18n.t('page.vehicle.financingAndLeasing.selectedCells', {count: selectedCount})}
      </Text>
      <Button
        title={i18n.t('general.actions.clear')}
        leftIcon="content/clear"
        variant="secondary"
        size="small"
        onClick={props.onClear}
        data-testid={suffixTestId('clearSelection', props)}
      />
      <Button
        title={i18n.t('page.vehicle.financingAndLeasing.setRates')}
        leftIcon="image/edit"
        size="small"
        onClick={handleOpenDialog}
        data-testid={suffixTestId('setRates', props)}
      />
    </HStack>
  );
}
